import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { MedicamentoService } from '../../../services/medicamento.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-pagina-importacao-excel',
    templateUrl: './pagina-importacao-excel.component.html',
    styleUrls: ['./pagina-importacao-excel.component.css'],
    standalone: false
})
export class PaginaImportacaoExcelComponent implements OnInit {
  pageSize = 10;
  pageIndex = 1;
  total = 11;
  loading = false;
  importacoes = [];
  isVisibleModalDetalhe = false;

  infoDetalharFalhas = [];
  pageSizeFalhas = 10;
  pageIndexFalhas = 1;
  totalFalhas = 11;
  loadingFalhas = false;
  idxlsx_medicamento_importacao = null;
  //pesquisa
  pesquisaDataInicial = null;
  pesquisaDataFinal = null;
  constructor(
    private medicamentoService: MedicamentoService,
    private message: NzMessageService,
  ) { }

  ngOnInit(): void {
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.medicamentoService.importacoes(params.pageIndex).subscribe((c:any)=>{

      this.importacoes = c.data.medicamento.data;
      this.total = c.data.medicamento.total;
      this.pageSize = c.data.medicamento.per_page;
      this.loading = false;
    });
  }

  recarregarImportacoes(){
    this.loading = true;
    this.medicamentoService.importacoes(this.pageIndex).subscribe((c:any)=>{
      this.importacoes = c.data.medicamento.data;
      this.total = c.data.medicamento.total;
      this.pageSize = c.data.medicamento.per_page;
      this.loading = false;
    });
  }

  reimportar(idxlsx_medicamento_importacao){
    this.loading = true;
    this.medicamentoService.reimportar(idxlsx_medicamento_importacao).subscribe((c:any) => {
      this.loading = false;
      this.recarregarImportacoes();
      
    });
  }

  onQueryParamsChangeFalha(params: NzTableQueryParams): void {
    this.loadingFalhas = true;
    this.medicamentoService.getFalhas(this.idxlsx_medicamento_importacao,params.pageIndex).subscribe((c:any)=>{
      this.infoDetalharFalhas = c.data.medicamento.data;
      this.totalFalhas = c.data.medicamento.total;
      this.pageSizeFalhas = c.data.medicamento.per_page;
      this.loadingFalhas = false;
    });
  }

  getFalhas(idxlsx_medicamento_importacao){
    this.loading = true;
    this.medicamentoService.getFalhas(idxlsx_medicamento_importacao, this.pageIndex).subscribe((c: any) => {
      this.idxlsx_medicamento_importacao = idxlsx_medicamento_importacao;
      this.loading = false;
    });
  }

  cancelModalFalhas(){
    this.isVisibleModalDetalhe = false;
  }

  showModalFalhas(idxlsx_medicamento_importacao): void {
    this.medicamentoService.getFalhas(idxlsx_medicamento_importacao, this.pageIndex).subscribe((c:any)=>{
      this.idxlsx_medicamento_importacao = idxlsx_medicamento_importacao;
      this.infoDetalharFalhas = c.data.medicamento.data;
      this.totalFalhas = c.data.medicamento.total;
      this.pageSizeFalhas = c.data.medicamento.per_page;
      this.loadingFalhas = false;
    });
    this.isVisibleModalDetalhe = true;
  }

  pesquisar(){
    var tpInicial = new Date(this.pesquisaDataInicial);
    var tpFinal = new Date(this.pesquisaDataFinal);

    if(tpInicial <= tpFinal){
      this.loading = true;
      this.medicamentoService.importacoes(1, this.pesquisaDataInicial, this.pesquisaDataFinal).subscribe((c:any)=>{
        this.importacoes = c.data.medicamento.data;
        this.total = c.data.medicamento.total;
        this.pageSize = c.data.medicamento.per_page;
        this.pageIndex = 1;
        this.loading = false;
      });
    }else{
      this.message.error('A data inicial é maior que a data final, a pesquisa não foi realizada.');
    }
    
  }

  cancelarPesquisa(){
    this.recarregarImportacoes();
    this.pesquisaDataFinal = null;
    this.pesquisaDataInicial = null;
  }
}